var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{attrs:{"controls":"","controlsList":"nodownload","autoplay":_vm.autoplay}},[_c('source',{attrs:{"src":_vm.url}}),_vm._v(" "+_vm._s(_vm.$t("noAudioSupport"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }